<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">
        {{ location }}
      </h2>
      <span>|</span>
      <h2 class="title title-primary">
        {{ $t("lang.online.order_gtin_detail.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.online.order_gtin_detail.page_title_line_2") }}
      </h3>
    </div>
    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row" style="margin: 8px">
          <bx-btn @click="$router.back()">{{
            $t("lang.messages.go_back")
          }}</bx-btn>
        </div>
        <div class="row">
          <div class="col-12">
            <bx-box
              title=""
              color="white"
              no-padding
              class=""
              v-if="!shouldLoading"
            >
              <bx-gtin :gtin="gtinData"></bx-gtin>
            </bx-box>

            <div
              class="row p-4 m-1"
              v-if="shouldLoading"
              style="background: white"
            >
              <div class="col-12 col-md-6">
                <PuSkeleton height="15px" class="title"></PuSkeleton>
                <PuSkeleton height="15px"></PuSkeleton>
                <hr />
                <PuSkeleton height="15px" class="title"></PuSkeleton>
                <PuSkeleton height="15px"></PuSkeleton>
                <hr />
                <PuSkeleton height="15px" class="title"></PuSkeleton>
                <PuSkeleton height="15px"></PuSkeleton>
                <hr />
                <PuSkeleton height="15px" class="title"></PuSkeleton>
                <PuSkeleton height="15px"></PuSkeleton>
                <hr />
                <PuSkeleton height="15px" class="title"></PuSkeleton>
                <PuSkeleton height="15px"></PuSkeleton>
                <hr />
              </div>
              <div class="col-12 col-md-6">
                <PuSkeleton class="skeleton-gtin-image"></PuSkeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BxBtn from "@/bx-components/BxBtn";

export default {
  name: "inbound-order-article-detail",
  components: { BxBtn },
  props: {
    gtin: {
      type: [Number, String]
    }
  },
  data() {
    return {
      shouldLoading: true,
      order: {},
      data: [],
      boxes: [],
      gtinData: {},
      reloadInterval: null
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    }
  },
  methods: {
    async getData() {
      // Gtin data
      const data = await this.$api.types.get(this.gtin);
      this.gtinData = {
        image: require("@/assets/i/demoArticle.jpg"),
        category: "Camisetas",
        code: data.description,
        size: data.size,
        color: data.colour,
        gtin: data.gtin,
        model: data.model,
        season: data.season,
        section: data.section
      };

      this.shouldLoading = false;
    }
  },
  mounted() {
    this.reloadInterval = setInterval(
      this.getData,
      process.env.VUE_APP_RELOAD_TIME
    );
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  }
};
</script>

<style scoped>
.detail-titles {
  min-height: 45px !important;
}

.skeleton-gtin-image {
  height: 270px;
}

@media screen and (min-width: 1025px) {
  .skeleton-gtin-image {
    height: 500px;
  }
}

@media screen and (max-width: 1024px) {
  .skeleton-gtin-image {
    height: 270px;
  }
}

@media screen and (max-width: 767px) {
  .skeleton-gtin-image {
    height: 240px;
  }
}

.title >>> span {
  width: 150px;
}
</style>
